import * as React from 'react';
import { useRouter } from 'next/router';

import {
  Lang,
  Breakpoint,

  useDimensions,
} from '@bluecurrent/web-component-lib';

import {
  getClient,
  overlayDrafts,
  sanityClient,
} from '../../src/services/Sanity/sanity.server';
import getBranchSlugs from '../../src/services/Sanity/query/getBranchSlugs';
import getBranch from '../../src/services/Sanity/query/getBranch';
import getBranches from '../../src/services/Sanity/query/getBranches';

import useSanityData from '../../src/hooks/useSanityData';

import handleFindPageData from '../../src/functions/handleFindPageData';

import Page from '../../src/config/Page.config';
import Setup from '../../src/config/Setup.config';

import PageBuilder from '../../src/components/PageBuilder';

import Head from '../../src/components/Modules/Head';

export default function BusinessPagesHandler({ data, slug }) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();
  const branches = useSanityData(
    getBranches('forms'),
  );
  const router = useRouter();

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;

  const [pageData, setPageData] = React.useState([]);
  const [isLoading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setPageData({
      data,
      branches,
    });

    if (data !== undefined && (branches.length > 0)) setLoading(false);
  }, [
    data,
    lang,
    branches,
  ]);

  const render = [
    { component: <PageBuilder data={pageData.data} /> },
  ];

  const getCurrentPage = () => !isLoading && handleFindPageData(pageData.branches, slug);

  React.useEffect(() => {
    if (getCurrentPage() === undefined) router.push('/404');
  }, [isLoading]);

  return (
    <>
      <Head
        title={(!isLoading && getCurrentPage() !== undefined) ? getCurrentPage().config.title[lang] : ''}
        type={!isLoading && slug}
        slug={!isLoading && `/forms/${slug}`}
      />
      <div
        style={{
          paddingTop: (!isLoading && pageData.data[0]?.layout[0]?.Components[0]?.form?.type === 'TypeForm')
            ? 0
            : size.width < Breakpoint.xxl
              ? 0
              : 15,
          minHeight: size.width < Breakpoint.lg
            ? Page.MIN_HEIGHT.small_screen
            : Page.MIN_HEIGHT.full_screen,
          height: 'auto',
        }}
      >
        {
          !isLoading && render.map((e, index) => (
            <React.Fragment
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
            >
              {e.component}
            </React.Fragment>
          ))
        }
      </div>
    </>
  );
}

export async function getStaticProps({ params, preview = false }) {
  // Get Branch
  const data = overlayDrafts(await getClient(preview).fetch(getBranch('forms', params.slug)));

  return {
    props: {
      data,
      slug: params.slug,
    },
    revalidate: 300,
  };
}

export async function getStaticPaths() {
  // Get Branches
  const branches = await sanityClient.fetch(getBranchSlugs('forms'));

  return {
    paths: branches.map((slug) => ({ params: { slug } })),
    fallback: true,
  };
}
